export default __webpack_public_path__ + "static/media/Contact.45d59c48.png";